import { InjectionToken } from '@angular/core';

export const DIALOG_CONTEXT = new InjectionToken<IDialogContext>('IDialogContext');

export interface IDialogContext {
  readonly id: string;
  close(isSuccess?: boolean): void;
}
